import { computed, ref, watch } from '@vue/composition-api'
import { ReportService } from '@/app/reports/share/report.service'



export default function GeofenceReportLogic() {


  const sortBy = ref('id')
  const isSortDirDesc = ref(true)

  const  today = new Date().toISOString().split('T')[0];
  const  defaultFromDate = `${today} 00:00:00`
  const  defaultToDate = `${today} 23:59:59`

  const from = ref(defaultFromDate)
  const to = ref(defaultToDate)

  const devicesList = ref([])
  const geofencesList = ref([])

  const request = computed(() => ({
    page: 1,
    length: 25,
    type: 'geofence',
    inside: true,
    from: from.value,
    to:  to.value,
    devices: devicesList.value,
    geofences: geofencesList.value
  }))

  // const request = ref({
  //   page: 1,
  //   length: 25,
  //   type: 'geofence',
  //   inside: true,
  //   from: defaultFromdate,
  //   to:  defaultTodate,
  //   devices: [],
  //   geofences: [],
  // //  report_period:'monthly'
  // })

  const report_data = ref(null)


  const total = ref(0)

  const errors = ref({})
  const loading = ref(false)
  const dataTableloading=ref(false)


  const getReport = (isSortRequest) => {

    errors.value = {}
    loading.value = true
   
    ReportService.getReport(request.value)
    
      .then(res => {
        report_data.value = res.data.data
        from.value = res.data.from
        to.value = res.data.to
        total.value = res.data.total
      })
      .catch(reason => reason.status === 422 ? errors.value = reason.data.errors : {})
      .finally(() =>  loading.value = false)
  }

  watch([sortBy,isSortDirDesc],()=>{
    console.log(sortBy.value+'  '+isSortDirDesc.value)
    request.value.sortBy=  isSortDirDesc.value==true? sortBy.value+',desc':sortBy.value+',asc';
    dataTableloading.value = true
   
    ReportService.getReport(request.value)
    
      .then(res => {
        dataTableloading.value=false;
        report_data.value = res.data.data
        from.value = res.data.from
        to.value = res.data.to
        total.value = res.data.total
      })
      .catch(reason => reason.status === 422 ? errors.value = reason.data.errors : {})
      .finally(() =>  dataTableloading.value = false)
  })


  const getReportForPdf = () => {
    loading.value = true
    return new Promise((r, j) => {
      ReportService.getReport({ ...Object.assign(request.value, {
        page:1
      }), length: 50000}).then(res => r(res.data.data))
        .finally(() =>  loading.value = false)
    })
  }


  return {
    getReport,getReportForPdf,
    report_data,
    total, from, to, devicesList, geofencesList,
    request,
    loading,
    errors,
    sortBy,
    isSortDirDesc,
    dataTableloading
  }
}
